export const InvoiceRouting = [
  {
    path: "/expense/invoice/list",
    name: "expense-invoice-list",
    meta: { title: "开票记录" },
    component: () =>
      import(/* webpackChunkName: "expense-invoice" */ "@/views/expense/invoice/list/index.vue"),
  },
];
